<div class="u-card">
    <form class="c-entry-group">
        @if (!enableEdit()) {
        <div class="c-data-list__item c-data-list-item">
            @if(configuration()) {
            <div class="c-data-list">
                <div class="c-data-list__item c-data-list-item">
                    <p class="c-data-list-item__key">{{ 'configuration.squareMetersPerLinearMeter' | translate }}</p>
                    <p class="c-data-list-item__value">{{ configuration().squareMetersPerLinearMeter || '-' }}</p>
                </div>
                <div class="c-data-list__item c-data-list-item">
                    <p class="c-data-list-item__key">{{ 'configuration.defaultCurrency' | translate }}</p>
                    <p class="c-data-list-item__value">{{ configuration().defaultCurrency || '-' }}</p>
                </div>
                <div class="c-data-list__item c-data-list-item">
                    <p class="c-data-list-item__key">{{ 'configuration.createdAt' | translate }}</p>
                    <p class="c-data-list-item__value">{{ DateUtils.format(configuration().createdAt) || '-' }}</p>
                </div>
            </div>
            } @else {
            <p>-</p>
            }
        </div>
        } @else {

        @for (field of generalFields; track field.key) {
        <div coreDynamicField [field]="field" [value]="configuration()[field.key] || ''" [mode]="ModalMode.EDIT"
            [errors]="getFieldErrors(field.key.toString())"
            (valueChange)="onFieldValueChange(field.key.toString(), $event)" (onBlurEvent)="validateAllFields()">
        </div>
        }
        <div class="u-flex--wrap u-push-t--xl">
            @if(enableEdit()) {
            <core-generic-button [config]="saveButtonConfig()" (buttonClick)="onSaveClick()">
            </core-generic-button>

            <core-generic-button [config]="cancelButtonConfig()" (buttonClick)="onCancelClick()">
            </core-generic-button>
            }
        </div>
        }
    </form>
</div>